<template>
  <div>
    <div>
      <div class="label mt-2 mb-1">Name</div>
      <input type="text" class="form-control" v-model="occurrence.name" />
    </div>
    <hr />
    <div>
      <div class="label">Part/ Tool Description</div>
      <textarea-autosize
        class="form-control comment-textarea"
        style="padding-right: 30px"
        rows="2"
        placeholder="Describe the part / tools..."
        v-model="occurrence.description"
        :min-height="50"
      ></textarea-autosize>
    </div>

    <div class="row mt-4">
      <div class="col-6">
        <div class="label">Part Number</div>
        <input type="text" class="form-control" v-model="occurrence.partNumber" />
      </div>
      <div class="col-6">
        <div class="label">Serial Number</div>
        <input type="text" class="form-control" v-model="occurrence.serialNumber" />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-6">
        <div class="label">PACKAGE DIMENSIONS (L x W x H) AND WEIGHT</div>
        <div class="d-flex justify-content-between align-items-center">
          <input type="number" class="form-control max-w-20" v-model="occurrence.packageLength" placeholder="Length" />
          <div class="label-xl ml-2 mr-2 text-nowrap">cm x</div>
          <input type="number" class="form-control" v-model="occurrence.packageWidth" placeholder="Width" />
          <div class="label-xl ml-2 mr-2 text-nowrap">cm x</div>
          <input type="number" class="form-control" v-model="occurrence.packageHeight" placeholder="Height" />
          <div class="label-xl ml-2 mr-2 text-nowrap">cm</div>
          <input type="number" class="form-control" v-model="occurrence.packageWeight" placeholder="Weight" />
          <div class="label-xl ml-2 mr-2">kg</div>
        </div>
      </div>

      <div class="col-2">
        <div class="label">Package Count</div>
        <div class="d-flex justify-content-between">
          <input type="number" class="form-control w-50" v-model="occurrence.packageCount" />
        </div>
      </div>

      <div class="col-4">
        <div class="label">TYPE OF PACKING</div>
        <input type="text" class="form-control w-100" v-model="occurrence.packageType" />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-6">
        <div class="label">Customs Clearance</div>

        <div class="row">
          <div class="col-6">
            <v-select
              :options="comatClearances"
              label="clearances"
              :clearable="false"
              :reduce="(c) => c"
              placeholder="Please select a clearance..."
              v-model="occurrence.clearanceStatus"
            ></v-select>
          </div>

          <input
            v-if="occurrence.clearanceStatus === 'Done'"
            type="text"
            class="col-6 form-control comat-reference"
            v-model="occurrence.clearanceComment"
            placeholder="Customs Reference MRN"
          />
        </div>
      </div>

      <div class="col-6">
        <div class="label">Certificate</div>
        <v-select
          :options="certificates"
          label="certificates"
          :clearable="false"
          :reduce="(c) => c"
          placeholder="Please select a Certificate..."
          v-model="occurrence.certificate"
        ></v-select>
      </div>
    </div>

    <hr />

    <!-- Origin && Destination -->
    <div class="row mt-4">
      <div class="col-4">
        <div class="label">Planned Date</div>
        <board-item-date-picker
          v-model="occurrence.plannedDate"
          :disabled="occurrence.isCompleted"
          :customClass="'comatPlannedDate'"
          placement="bottom"
          mode="date"
        ></board-item-date-picker>
      </div>
      <div class="col-4">
        <div class="label">Origin</div>
        <v-select
          :options="origins"
          label="iataCode"
          :clearable="false"
          :reduce="(origin) => origin.iataCode"
          placeholder="Please select a Origin..."
          v-model="occurrence.origin"
          :disabled="occurrence.isCompleted"
        ></v-select>
      </div>
      <div class="col-4">
        <div class="label">Destination</div>
        <v-select
          :options="origins"
          label="iataCode"
          :clearable="false"
          :reduce="(destination) => destination.iataCode"
          placeholder="Please select a Destination..."
          v-model="occurrence.destination"
          :disabled="occurrence.isCompleted"
        ></v-select>
      </div>
    </div>

    <div class="mt-4">
      <div class="label">Shipper</div>
      <input type="text" class="form-control" v-model="occurrence.shipper" />
    </div>

    <div class="mt-4" v-if="occurrence.flights && occurrence.flights.length">
      <div class="label">Selected Flights</div>

      <div v-for="(occFlight, index) in occurrence.flights" :key="occFlight.id + index">
        <div class="d-flex justify-content-start">
          <div :class="{ 'so-flight-parent': index === 0, 'so-flight-child': index > 0, 'pr-2': occurrence.isCompleted }">
            <FlightInfo :flight="occFlight"></FlightInfo>
          </div>
          <i
            v-if="index === 0 && !occurrence.isCompleted && userCanEdit"
            class="so-flight-remove far fa-trash-alt cursor-pointer"
            v-on:click="removeFlight(occFlight)"
          ></i>
        </div>
      </div>
    </div>

    <div class="mt-2 justify-content-between d-flex" v-if="!occurrence.isCompleted">
      <div>
        <div v-b-tooltip.hover.right :title="errorTitle" v-if="!showAddFlightsModal">
          <button :disabled="modelInvalid" class="btn btn-block btn-sm btn-success mt-2 mb-2" @click="addAffectedFlights()">
            <i class="fas fa-plus"></i>
            Add affected Flight
          </button>
        </div>
        <div v-b-tooltip.hover.auto :title="'Loading...'" v-else>
          <div class="container">
            <div class="row">
              <div>
                <button disabled class="btn btn-block btn-sm btn-success mt-2 mb-2">
                  <i class="fas fa-plus"></i>
                  Loading affected flights
                </button>
              </div>
              <div>
                <loading-spinner class="loadFlightsLoader" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <button class="btn btn-block btn-sm btn-success mt-2 mb-3" @click="saveChanges()">
          <i class="far fa-save"></i>
          Save Changes
        </button>
      </div>
    </div>

    <div class="d-flex justify-content-end comat-actions">
      <div class="label mr-2">
        <button class="btn btn-block btn-sm btn-secondary mt-2 mb-2" @click="getTransportRequestUrl()">
          <i class="far fa-file-pdf mr-2"></i>
          COMAT Transport Request
        </button>
      </div>

      <div class="label">
        <button class="btn btn-block btn-sm btn-secondary mt-2 mb-2" @click="getStickerUrl()">
          <i class="far fa-file-pdf mr-2"></i>
          COMAT Sticker
        </button>
      </div>
    </div>

    <b-modal
      ref="addComatFlight"
      id="addComatFlight"
      body-class="modal-body-wo"
      hide-footer
      hide-header
      size="xl"
      title="Add Affected Flight"
    >
      <ComatFlightsSelector v-on:saveComatRoute="saveRoutes" v-on:closeRoutesModal="showAddFlightsModal = false"></ComatFlightsSelector>
    </b-modal>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {
    ComatDto,
    SpecialOccurrenceAccessLevel,
    SpecialOccurrenceFlightInsertDto
  } from "@/apiclient/apiclient_generated";
  import { Prop } from 'vue-property-decorator';
  import { SpecialOccurrenceModule, SpecialOccurrenceStore } from '@/store/specialOccurrence';
  import { GlobalHelper } from '@/helpers/global-helper';
  import ComatFlightsSelector from '@/components/SpecialOccurrence/Data/Flights/ComatFlightsSelector.vue';
  import FlightInfo from "@/components/SpecialOccurrence/Data/Flights/FlightInfo.vue";

  @Component({
    components: { FlightInfo, ComatFlightsSelector },
  })
  export default class ComatData extends Vue {
    @Prop() occurrence: ComatDto;
    private store: SpecialOccurrenceModule = SpecialOccurrenceStore;
    private showAddFlightsModal = false;

    get comatClearances() {
      return ['Done', 'Not Done'];
    }

    get certificates() {
      return ['EASA Form 1', 'FAA 8130-3', 'Certificate of Conformity'];
    }

    get origins() {
      return this.store.airports;
    }

    async getTransportRequestUrl() {
      const file = await this.store.getComatTransportReport(this.occurrence.id);

      this.downloadFile(file.data, file.fileName);
    }

    get errorTitle() {
      if (this.modelInvalid) return 'Please select Origin, Destination and Planned date.';
      return null;
    }

    get userCanEdit() {
      return (
          this.store.currentOccurrenceUserAccessLevel == SpecialOccurrenceAccessLevel.Admin ||
          this.store.currentOccurrenceUserAccessLevel == SpecialOccurrenceAccessLevel.Editor
      );
    }

    get modelInvalid() {
      const occ = this.occurrence as ComatDto;
      return !occ.origin || !occ.destination || !occ.plannedDate;
    }

    private downloadFile(blob, label) {
      const link = document.createElement('a');

      link.href = URL.createObjectURL(blob);
      link.download = label;
      link.click();

      URL.revokeObjectURL(link.href);
    }

    async getStickerUrl() {
      const file = await this.store.getComatStickerReport(this.occurrence.id);

      this.downloadFile(file.data, file.fileName);
    }

    async saveChanges() {
      await this.store.saveOccurrenceDataChanges(this.occurrence);
      GlobalHelper.NotifySuccess('Special Occurrence updated');

      await this.store.loadData();
    }

    async saveRoutes(flights) {
      this.store.currentOccurrence.flights = [];
      this.store.currentOccurrence.flights = [...flights];

      const dto = {
        occurrenceId: this.occurrence.id,
        flights: this.store.currentOccurrence.flights,
      } as SpecialOccurrenceFlightInsertDto;

      await this.store.saveOccurrenceFlights(dto);

      GlobalHelper.NotifySuccess('COMAT routes updated');
    }

    async addAffectedFlights() {
      this.showAddFlightsModal = true;
      await this.store.saveOccurrenceDataChanges(this.occurrence);

      const comat = this.occurrence as ComatDto;

      await this.store.getComatRoutings({
        departure: comat.origin,
        arrival: comat.destination,
        date: comat.plannedDate,
      });

      const modal: any = this.$refs['addComatFlight'];
      modal.show();
    }

    async removeFlight() {
      this.occurrence.flights = [];
      await this.saveRoutes(this.occurrence.flights);
    }
  }
</script>

<style scoped lang="scss">
  .w-20 {
    width: 20% !important;
    min-width: 100px;
  }

  .w-50 {
    min-width: 150px;
  }

  .label-xl {
    font-weight: 600;
    color: #888 !important;
  }

  .comat-reference {
    height: calc(1.3em + 0.75rem + 2px) !important;
  }

  .comat-actions {
    a {
      color: white;
      text-decoration: none;
      background-color: transparent;
    }
  }

  .so-flight-parent {
    flex: 1;
    padding-right: 10px;
  }
  .so-flight-child {
    flex: 1;
  }

  .so-flight-remove {
    margin-top: 5px;
    color: red;
  }
</style>
